/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Popup } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logAction } from "../actions/changeActiveItemActions";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const MAX_PB_NETWORK_DEVICES = 130;
const LINE_MAP_PLACEHOLDER = <React.Fragment><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell></React.Fragment>;

const START_MULTIPLIER = 10;
const END_INCREMENT = 10;

const UtilsInstance = new Utils();

class LiveList extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      sortDirection: "ascending",
      devices: [],
      devicesMatrixList: [],
      firstLineMap: LINE_MAP_PLACEHOLDER,
      secondLineMap: LINE_MAP_PLACEHOLDER,
      thirdLineMap: LINE_MAP_PLACEHOLDER,
      fourthLineMap: LINE_MAP_PLACEHOLDER,
      fifthLineMap: LINE_MAP_PLACEHOLDER,
      sixthLineMap: LINE_MAP_PLACEHOLDER,
      seventhLineMap: LINE_MAP_PLACEHOLDER,
      eightLineMap: LINE_MAP_PLACEHOLDER,
      ninethLineMap: LINE_MAP_PLACEHOLDER,
      tenthLineMap: LINE_MAP_PLACEHOLDER,
      eleventhLineMap: LINE_MAP_PLACEHOLDER,
      twelfthLineMap: LINE_MAP_PLACEHOLDER,
      thirtheenthLineMap: LINE_MAP_PLACEHOLDER,
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ devices: data }, () => {
        this.setState({ devicesMatrixList: [] }, () => {
          this.createLiveListMatrixList();
          this.buildLineMaps();
        });
      }));
  }

  createLiveListMatrixList = () => {
    let totalNumOfDevices = this.state.devices.length;
    let numOfInsertedDevices = 0;

    for (let i = 0; i < MAX_PB_NETWORK_DEVICES; i++) {
      let hasPositionBeenFilled = false;

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfInsertedDevices < totalNumOfDevices) {
        for (let j = 0; j < this.state.devices.length; j++) {
          if (this.state.devices[j].address === i) {
            this.state.devicesMatrixList.push(this.state.devices[j]);
            hasPositionBeenFilled = true;
            numOfInsertedDevices++;
            break;
          }
        }
      }

      if (!hasPositionBeenFilled) {
        this.state.devicesMatrixList.push({
          "address": i,
          "tag": "",
          "model": "",
          "status": "",
          "diagnostics": -1,
          "retries": -1,
          "faults": -1,
          "lastEvent": null,
          "isInBlacklist": false,
          "isInAutomaticBlacklist": false
        });
      }
    }
  }

  buildLineMaps = () => {
    let firstLineStart = START_MULTIPLIER * (1 - 1);
    let firstLineEnd = firstLineStart + END_INCREMENT;

    let secondLineStart = START_MULTIPLIER * (2 - 1);
    let secondLineEnd = secondLineStart + END_INCREMENT;

    let thirdLineStart = START_MULTIPLIER * (3 - 1);
    let thirdLineEnd = thirdLineStart + END_INCREMENT;

    let fourthLineStart = START_MULTIPLIER * (4 - 1);
    let fourthLineEnd = fourthLineStart + END_INCREMENT;

    let fifthLineStart = START_MULTIPLIER * (5 - 1);
    let fifthLineEnd = fifthLineStart + END_INCREMENT;

    let sixthLineStart = START_MULTIPLIER * (6 - 1);
    let sixthLineEnd = sixthLineStart + END_INCREMENT;

    let seventhLineStart = START_MULTIPLIER * (7 - 1);
    let seventhLinEnd = seventhLineStart + END_INCREMENT;

    let eightLineStart = START_MULTIPLIER * (8 - 1);
    let eightLineEnd = eightLineStart + END_INCREMENT;

    let ninethLineStart = START_MULTIPLIER * (9 - 1);
    let ninethLineEnd = ninethLineStart + END_INCREMENT;

    let tenthLineStart = START_MULTIPLIER * (10 - 1);
    let tenthLineEnd = tenthLineStart + END_INCREMENT;

    let eleventhLineStart = START_MULTIPLIER * (11 - 1);
    let eleventhLineEnd = eleventhLineStart + END_INCREMENT;

    let twelfthLineStart = START_MULTIPLIER * (12 - 1);
    let twelfthLineEnd = twelfthLineStart + END_INCREMENT;

    let thirtheenthLineStart = START_MULTIPLIER * (13 - 1);
    let thritheenthLineEnd = thirtheenthLineStart + END_INCREMENT;

    let firstLine = this.state.devicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondLine = this.state.devicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdLine = this.state.devicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthLine = this.state.devicesMatrixList.slice(fourthLineStart, fourthLineEnd);
    let fifthLine = this.state.devicesMatrixList.slice(fifthLineStart, fifthLineEnd);
    let sixthLine = this.state.devicesMatrixList.slice(sixthLineStart, sixthLineEnd);
    let seventhLine = this.state.devicesMatrixList.slice(seventhLineStart, seventhLinEnd);
    let eightLine = this.state.devicesMatrixList.slice(eightLineStart, eightLineEnd);
    let ninethLine = this.state.devicesMatrixList.slice(ninethLineStart, ninethLineEnd);
    let tenthLine = this.state.devicesMatrixList.slice(tenthLineStart, tenthLineEnd);
    let eleventhLine = this.state.devicesMatrixList.slice(eleventhLineStart, eleventhLineEnd);
    let twelfthLine = this.state.devicesMatrixList.slice(twelfthLineStart, twelfthLineEnd);
    let thirtheenthLine = this.state.devicesMatrixList.slice(thirtheenthLineStart, thritheenthLineEnd);

    this.setState({
      firstLineMap: firstLine.map(device => (this.createDeviceCell(device))),
      secondLineMap: secondLine.map(device => (this.createDeviceCell(device))),
      thirdLineMap: thirdLine.map(device => (this.createDeviceCell(device))),
      fourthLineMap: fourthLine.map(device => (this.createDeviceCell(device))),
      fifthLineMap: fifthLine.map(device => (this.createDeviceCell(device))),
      sixthLineMap: sixthLine.map(device => (this.createDeviceCell(device))),
      seventhLineMap: seventhLine.map(device => (this.createDeviceCell(device))),
      eightLineMap: eightLine.map(device => (this.createDeviceCell(device))),
      ninethLineMap: ninethLine.map(device => (this.createDeviceCell(device))),
      tenthLineMap: tenthLine.map(device => (this.createDeviceCell(device))),
      eleventhLineMap: eleventhLine.map(device => (this.createDeviceCell(device))),
      twelfthLineMap: twelfthLine.map(device => (this.createDeviceCell(device))),
      thirtheenthLineMap: thirtheenthLine.map(device => (this.createDeviceCell(device))),
    });
  }

  handleCellClick = (address) => () => {
    this.props.onChangeLog();
    this.props.history.push({
      pathname: "/log",
      state: { deviceAddress: address }
    });
  }

  createDeviceCell = (device) => {
    if (device.isInBlacklist) {
      if (device.lastEvent === null) {
        return <Table.Cell selectable
          key={device.address}
          style={blacklistCellStyle}
          onClick={this.handleCellClick(device.address, device.status)}>
          {Strings.BLACKLIST_STRING}
        </Table.Cell>;
      }
      else {
        return (
          <Popup position='bottom center'
            key={device.address}
            trigger={
              <Table.Cell selectable
                key={device.address}
                style={blacklistCellStyle}
                onClick={this.handleCellClick(device.address, device.status)}>
                {Strings.BLACKLIST_STRING}
              </Table.Cell>}>
            <Popup.Content>
              {this.getDeviceTooltip(device)}
            </Popup.Content>
          </Popup>
        );
      }
    }
    else if (device.isInAutomaticBlacklist) {
      if (device.lastEvent === null) {
        return <Table.Cell selectable
          key={device.address}
          style={criticSlaveCellStyle}
          onClick={this.handleCellClick(device.address, device.status)}>
          {Strings.CRITIC_SLAVE_STRING}
        </Table.Cell>;
      }
      else {
        return (
          <Popup position='bottom center'
            key={device.address}
            trigger={
              <Table.Cell selectable
                key={device.address}
                style={criticSlaveCellStyle}
                onClick={this.handleCellClick(device.address, device.status)}>
                {Strings.CRITIC_SLAVE_STRING}
              </Table.Cell>}>
            <Popup.Content>
              {this.getDeviceTooltip(device)}
            </Popup.Content>
          </Popup>
        );
      }
    }
    else {
      if (device.status === Constants.OK) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={okCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.OK_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={okCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.OK_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }

      }
      else if (device.status === Constants.DIAGNOSTIC) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={diagnosticCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.DIAGNOSTIC_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={diagnosticCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.DIAGNOSTIC_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }

      }
      else if (device.status === Constants.ONLINE) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={onlineCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.ONLINE_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={onlineCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.ONLINE_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={faultCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.FAULT_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={faultCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.FAULT_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={configErrorCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.CONFIG_ERROR_1}<br />{Strings.CONFIG_ERROR_2}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={configErrorCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.CONFIG_ERROR_1}<br />{Strings.CONFIG_ERROR_2}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }

      }
      else if (device.status === Constants.PARAM_ERROR) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={paramErrorCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.PARAM_ERROR_1}<br />{Strings.PARAM_ERROR_2}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={paramErrorCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.PARAM_ERROR_1}<br />{Strings.PARAM_ERROR_2}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.MASTER) {
        if (device.lastEvent === null) {
          if (device.masterStatus !== null) {
            return (
              <Table.Cell selectable
                key={device.address}
                style={masterCellStyle}
                onClick={this.handleCellClick(device.address, device.status)}>
                {Strings.MASTER_FAULT_STRING}<br />
                {UtilsInstance.getMasterStatusText(device.masterStatus)}
              </Table.Cell>
            );
          }
          else {
            return (
              <Table.Cell selectable
                key={device.address}
                style={masterCellStyle}
                onClick={this.handleCellClick(device.address, device.status)}>
                {Strings.MASTER_FAULT_STRING}<br />
                {Strings.CLASS_2}
              </Table.Cell>
            );
          }
        }
        else {
          if (device.masterStatus !== null) {
            return (
              <Popup position='bottom center'
                key={device.address}
                trigger={
                  <Table.Cell selectable
                    key={device.address}
                    style={masterCellStyle}
                    onClick={this.handleCellClick(device.address, device.status)}>
                    {Strings.MASTER_FAULT_STRING}<br />
                    {UtilsInstance.getMasterStatusText(device.masterStatus)}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
          else {
            return (
              <Popup position='bottom center'
                key={device.address}
                trigger={
                  <Table.Cell selectable
                    key={device.address}
                    style={masterCellStyle}
                    onClick={this.handleCellClick(device.address, device.status)}>
                    {Strings.MASTER_FAULT_STRING}<br />
                    {Strings.CLASS_2}
                  </Table.Cell>}>
                <Popup.Content>
                  {this.getDeviceTooltip(device)}
                </Popup.Content>
              </Popup>
            );
          }
        }
      }
      else if (device.status === Constants.MASTER_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={faultCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.MASTER_HASHTAG}{device.address}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={faultCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.MASTER_HASHTAG}{device.address}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.SLAVE_MASTER_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={slaveMasterFaultCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.SLAVE_MASTER_FAULT_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={slaveMasterFaultCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.SLAVE_MASTER_FAULT_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.MISSING) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={missingCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.MISSING_SINGULAR_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={missingCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.MISSING_SINGULAR_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
      else if (device.status === Constants.MPI) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={mpiCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.MPI_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={mpiCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.MPI_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }

      }
      else if (device.status === Constants.MPI_FAULT) {
        if (device.lastEvent === null) {
          return (
            <Table.Cell selectable
              key={device.address}
              style={faultCellStyle}
              onClick={this.handleCellClick(device.address, device.status)}>
              {Strings.MPI_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell selectable
                  key={device.address}
                  style={faultCellStyle}
                  onClick={this.handleCellClick(device.address, device.status)}>
                  {Strings.MPI_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }

      }
      else {
        if (device.lastEvent === null) {
          return (
            <Table.Cell
              disabled
              key={device.address}
              style={hiddenTableCellStyle}>
              {Strings.OK_STRING}
            </Table.Cell>
          );
        }
        else {
          return (
            <Popup position='bottom center'
              key={device.address}
              trigger={
                <Table.Cell
                  disabled
                  key={device.address}
                  style={hiddenTableCellStyle}>
                  {Strings.OK_STRING}
                </Table.Cell>}>
              <Popup.Content>
                {this.getDeviceTooltip(device)}
              </Popup.Content>
            </Popup>
          );
        }
      }
    }
  }

  getDeviceTooltip = (device) => {
    if (device.lastEvent.length === 1) {
      return Strings.LAST_EVENT + device.lastEvent[0];
    }
    else {
      if (device.lastEvent.length >= 4) {
        let lastEventString = Strings.LAST_EVENT + Strings.LAST_EVENT_TOO_BIG_STRING;
        return lastEventString;
      }
      else {
        let listItems = device.lastEvent.map((event) => (
          <li key={Math.random()}>{event}</li>
        ));

        return (
          <div>
            <p>{Strings.LAST_EVENT}</p>
            <ul>
              <li>{listItems}</li>
            </ul>
          </div>
        );
      }
    }
  }

  getTableBasedOnWindowHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();

    let browserHeightStyle = {
      height: browserHeight * 0.85
    };

    let tableSize = "large";

    if (browserHeight > 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "large";
    }
    else if (browserHeight > 650 && browserHeight <= 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "small";
    }
    else {
      browserHeightStyle = {
        height: browserHeight * 0.65
      };
      tableSize = "small";
    }

    return (
      <Table id="main-table" compact celled fixed singleLine textAlign="center" size={tableSize} definition style={browserHeightStyle}>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell width="1" />
            <Table.HeaderCell>0</Table.HeaderCell>
            <Table.HeaderCell>1</Table.HeaderCell>
            <Table.HeaderCell>2</Table.HeaderCell>
            <Table.HeaderCell>3</Table.HeaderCell>
            <Table.HeaderCell>4</Table.HeaderCell>
            <Table.HeaderCell>5</Table.HeaderCell>
            <Table.HeaderCell>6</Table.HeaderCell>
            <Table.HeaderCell>7</Table.HeaderCell>
            <Table.HeaderCell>8</Table.HeaderCell>
            <Table.HeaderCell>9</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row><Table.Cell verticalAlign="middle">0</Table.Cell>{this.state.firstLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">10</Table.Cell>{this.state.secondLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">20</Table.Cell>{this.state.thirdLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">30</Table.Cell>{this.state.fourthLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">40</Table.Cell>{this.state.fifthLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">50</Table.Cell>{this.state.sixthLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">60</Table.Cell>{this.state.seventhLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">70</Table.Cell>{this.state.eightLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">80</Table.Cell>{this.state.ninethLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">90</Table.Cell>{this.state.tenthLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">100</Table.Cell>{this.state.eleventhLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">110</Table.Cell>{this.state.twelfthLineMap}</Table.Row>
          <Table.Row><Table.Cell verticalAlign="middle">120</Table.Cell>{this.state.thirtheenthLineMap}</Table.Row>
        </Table.Body>
      </Table>
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    let intervalID = setInterval(this.retrieveData, 5000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // Render the table containing all network devices
  render() {
    return (
      this.getTableBasedOnWindowHeight()
    );
  }
}

// CSS custom table stylization

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const diagnosticCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const onlineCellStyle = {
  color: "black",
  backgroundColor: "lightBlue",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "red",
  verticalAlign: "middle"
};

const configErrorCellStyle = {
  color: "black",
  backgroundColor: "LightPink",
  verticalAlign: "middle"
};

const paramErrorCellStyle = {
  color: "white",
  backgroundColor: "MediumVioletRed",
  verticalAlign: "middle"
};

const masterCellStyle = {
  color: "black",
  backgroundColor: "white",
  verticalAlign: "middle"
};

const mpiCellStyle = {
  color: "white",
  backgroundColor: "#000080",
  verticalAlign: "middle"
};

const blacklistCellStyle = {
  color: "white",
  backgroundColor: "black",
  verticalAlign: "middle"
};

const criticSlaveCellStyle = {
  color: "white",
  backgroundColor: "darkRed",
  verticalAlign: "middle"
};

const slaveMasterFaultCellStyle = {
  color: "white",
  backgroundColor: "#B22222",
  verticalAlign: "middle"
};

const missingCellStyle = {
  color: "white",
  backgroundColor: "#708090",
  verticalAlign: "middle"
};

const mapActionsToProps = {
  onChangeLog: logAction
};

const hiddenTableCellStyle = {
  color: "white"
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));



